import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const sha256 = async (mensaje) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(mensaje);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
};

const Login = () => {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const claveHash = await sha256(clave);
      const response = await axios.post('https://casinop2.sanjoseapps.cl/api/login.php', {
        usuario,
        clave: claveHash
      });
      if (response.data.success) {
        localStorage.setItem('usuario', 'Admin');
        setTimeout(() => {
            navigate('/dashboard', { replace: true });
          }, 100);
      } else {
        setError('❌ Credenciales incorrectas');
      }
    } catch (err) {
      console.error('Error de login:', err);
      setError('❗ Error en la conexión con el servidor');
    }
  };

  return (
    <section className="hero is-fullheight is-light">
      <div className="hero-body">
        <div className="container" style={{ maxWidth: 400 }}>
          <div className="box p-5">
            <h1 className="title has-text-centered mb-4">🎫 Sistema de Casino</h1>
            {error && <div className="notification is-danger is-light">{error}</div>}
            <form onSubmit={handleLogin}>
              <div className="field">
                <label className="label">Usuario</label>
                <div className="control has-icons-left">
                  <input
                    className="input"
                    type="text"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    required
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-user"></i>
                  </span>
                </div>
              </div>

              <div className="field">
                <label className="label">Contraseña</label>
                <div className="control has-icons-left">
                  <input
                    className="input"
                    type={showPassword ? 'text' : 'password'}
                    value={clave}
                    onChange={(e) => setClave(e.target.value)}
                    required
                    style={{ paddingRight: '2.5rem' }} // para que no tape el botón
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-lock"></i>
                  </span>

                  <button
                    type="button"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#363636'
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>
              <div className="field mt-4">
                <button className="button is-primary is-fullwidth" type="submit">
                  Ingresar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
